var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3095_246349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5054 15.7129C30.5054 14.6933 30.4227 13.6681 30.2464 12.665H16.0979V18.4412H24.2001C23.8639 20.3041 22.7836 21.9521 21.2017 22.9994V26.7473H26.0355C28.874 24.1348 30.5054 20.2766 30.5054 15.7129Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0977 30.3685C20.1433 30.3685 23.555 29.0402 26.0408 26.7473L21.207 22.9994C19.8622 23.9143 18.126 24.4324 16.1032 24.4324C12.19 24.4324 8.87194 21.7923 7.68142 18.2428H2.69336V22.1065C5.23975 27.1717 10.4262 30.3685 16.0977 30.3685V30.3685Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67608 18.2428C7.04775 16.3799 7.04775 14.3626 7.67608 12.4997V8.63599H2.69353C0.566025 12.8745 0.566025 17.868 2.69353 22.1065L7.67608 18.2428V18.2428Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0977 6.30451C18.2363 6.27144 20.3031 7.07614 21.8519 8.55327L26.1345 4.2707C23.4227 1.72431 19.8236 0.324349 16.0977 0.368442C10.4262 0.368442 5.23975 3.56521 2.69336 8.63594L7.67591 12.4996C8.86091 8.9446 12.1845 6.30451 16.0977 6.30451V6.30451Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3095_246349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.797852 0.367432)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleicon);
export default __webpack_public_path__ + "static/media/google.icon.ca0411915608cd1369d60752ac2b877d.svg";
export { ForwardRef as ReactComponent };